import { reportService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    statistics: {
        total_transactions: 0,
        total_wage: 0,
        unsettled_balance: 0,
        settled_amount: 0,
        settled_balance: 0,
    },
    gatewayStatistics: {
        monthly_transactions: 0,
        daily_transactions: 0,
        total_transactions: 0,
        unsettled_balance: 0,
        settled_balance: 0,
        total_wage: 0,
    },
    userStatistics: {
        accounting_info: {
            settled_amount: 0,
            total_wage: 0,
            total_balance: 0,
            total_transactions: 0,
        },
        login_info: {
            user_level: 0,
            created_at: 0,
            last_ip_login: 0,
            last_update: 0,
        }
    },
    taxExports: {},
    officialFactor: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
        state.statistics = []
        state.userStatistics = []
        state.gatewayStatistics = []
    },
    success(state, statistics) {
        state.status    = 'success'
        state.statistics = statistics
    },
    gatewayStatistics(state, gatewayStatistics) {
       state.status = 'gateway-success'
       state.gatewayStatistics = gatewayStatistics
    },

    userStatistics(state, userStatistics) {
       state.status = 'user-success'
       state.userStatistics = userStatistics
    },

    taxExports(state, taxExports) {
        state.status = 'success'
        state.taxExports = taxExports
    },

    officialFactor(state, officialFactor) {
        state.status = 'success'
        state.officialFactor = officialFactor
    },

    fail(state) {
        state.status    = 'fail'
        state.statistics = []
    },
}

const getters = {
    status: state => state.status,
    statistics: state => state.statistics,
    gatewayStatistics: state => state.gatewayStatistics,
    userStatistics: state => state.userStatistics,
    taxExports: state => state.taxExports,
    officialFactor: state => state.officialFactor
}

const actions = {
    fetchGatewaysStatistics({commit}, query) {
        commit('loading')
        return reportService.fetchGatewaysStatistics(query)
            .then(response => {
                commit('success', response.data.data)
            })
    },

    fetchUsersStatistics({commit}, query) {
        commit('loading')
        return reportService.fetchUsersStatistics(query)
            .then(response => {
                commit('success', response.data.data)
            })
    },

    gatewayDetails({commit}, params) {
        commit ('loading')
        return reportService.gatewayDetails(params).then(response => {
            commit('gatewayStatistics', response.data.data)
            })
    },

    fetchTaxExports({commit}) {
        commit ('loading')
        return reportService.fetchTaxExports().then(response => {
            commit ('taxExports', response.data.data)
        });
    },

    fetchUserOfficialFactor({commit}, query) {
        commit ('loading')
        return reportService.fetchUserOfficialFactor(query).then(response => {
            commit ('officialFactor', response.data.data)
        });
    },

    userDetails({commit}, hashid) {
        commit ('loading')
        return reportService.userDetails(hashid)
            .then(response => {
                commit('userStatistics', response.data.data)
            })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}